import { useEffect, useState } from "react";

function CopyAddress({ theme, setCopyAddressStatus }) {
  const [active, setActive] = useState(false);

  useEffect(() => {
    setActive(true);

    setTimeout(() => {
      setActive(false);

      setTimeout(() => {
        setCopyAddressStatus(false);
      }, 150);
    }, 1500);
  }, []);

  return (
    <div className={`copiedMessageDiv ${theme} ${active && "active"}`}>
      Copied
    </div>
  );
}

export default CopyAddress;
